/** Mirrors `lib/utils/phone_contact_match.dart` for web reports and labels. */

export function normalizePhoneDigits(s: string | undefined | null): string {
  if (!s) return '';
  return s.replace(/\D/g, '');
}

/**
 * Keys used to match a phone string to contact names / saved numbers.
 * Includes +91 / 10-digit India bridging (same as mobile).
 */
export function phoneMatchKeySet(d: string): Set<string> {
  const out = new Set<string>();
  if (!d) return out;
  out.add(d);
  if (d.length >= 10) out.add(d.slice(-10));
  if (d.length === 10) out.add(`91${d}`);
  if (d.length >= 12 && d.startsWith('91')) {
    const afterCc = d.slice(2);
    if (afterCc) {
      out.add(afterCc);
      if (afterCc.length >= 10) out.add(afterCc.slice(-10));
    }
  }
  return out;
}

export function indexContactPhoneForDisplayLookup(
  normalizedDigits: string,
  displayName: string,
  into: Map<string, string>,
): void {
  if (!normalizedDigits) return;
  for (const key of phoneMatchKeySet(normalizedDigits)) {
    if (!into.has(key)) into.set(key, displayName);
  }
}

export function lookupContactDisplayName(
  memberPhone: string | undefined | null,
  phoneToContactName: Map<string, string>,
): string | null {
  if (phoneToContactName.size === 0) return null;
  const d = normalizePhoneDigits(memberPhone);
  if (!d) return null;
  for (const key of phoneMatchKeySet(d)) {
    const v = phoneToContactName.get(key);
    if (v) return v;
  }
  if (d.length === 10) {
    for (const [key, value] of phoneToContactName) {
      if (key.length > d.length && key.endsWith(d)) return value;
    }
  }
  return null;
}

export function phoneDigitsMatchSamePerson(aDigits: string, bDigits: string): boolean {
  if (!aDigits || !bDigits) return false;
  if (aDigits === bDigits) return true;
  if (aDigits.length >= 10 && bDigits.length >= 10) {
    if (aDigits.slice(-10) === bDigits.slice(-10)) return true;
  }
  if (
    aDigits.length === 10 &&
    bDigits.length > aDigits.length &&
    bDigits.endsWith(aDigits)
  ) {
    return true;
  }
  if (
    bDigits.length === 10 &&
    aDigits.length > bDigits.length &&
    aDigits.endsWith(bDigits)
  ) {
    return true;
  }
  const sa = phoneMatchKeySet(aDigits);
  for (const k of phoneMatchKeySet(bDigits)) {
    if (sa.has(k)) return true;
  }
  return false;
}
